'use client';

import * as React from 'react';
import { clsx } from 'clsx';
import styles from './IconButton.module.css';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'md';
}

export function IconButton({ size = 'md', className, children, ...props }: IconButtonProps) {
  return (
    <button
      type="button"
      className={clsx(styles.iconButton, styles[size], className)}
      {...props}
    >
      {children}
    </button>
  );
}
